import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Card, Collapse } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from "../../assets/landingFeatures/qhrFlow.png";
import Footer from "../footer";
import { Button, Empty ,} from "antd";
import workflow from "../../assets/landingFeatures/workflow.jpg";
import profileIcon from "../../assets/profile.png";
import { MenuOutlined } from "@ant-design/icons";

import LandingHeader from "../header";
import "./qhrflowlanding.scss";

function QHRFlowContact(props) {
  const [loader, SetLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleSubmit } = props;
  const { Meta } = Card;
  const [contactType, setContactType] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const inputStyle = {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    marginTop: "5px",
  };
  const onChange = (key) => {
    console.log(key);
  };

  // Scrolls to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

const handleContact = (type) => {
  setContactType(type);

  if (type === "demo") {
    setMessage("Hi Team,\nI would like to request a demo for qhrflow");
  }

  if (type === "sales") {
    setMessage("Hi Team,\nI want to discuss pricing and plans.");
  }

  if (type === "support") {
    setMessage("Hi Team,\n I have a query -");
  }

  // scroll to form
  setTimeout(() => {
    document.getElementById("contact-form")?.scrollIntoView({ behavior: "smooth" });
  }, 100);
};
  return (
    <div className="qhrflowlanding-wrapper">
        <LandingHeader />

      <div className="landing-features features-wrapper">
        <div className="qhrflowlanding-features">
            <div style={{ maxWidth: "900px", margin: "60px auto", textAlign: "center" }}>
              
              {/* HEADER */}
              <div style={{ marginBottom: "30px" }}>
                <h1 style={{ fontSize: "32px", fontWeight: 600 }}>
                  Get Started with QuallyHire
                </h1>
                <p style={{ color: "#6b7280", fontSize: "16px" }}>
                  Whether you want a demo, pricing, or support — we’ll get back within 24 hours.
                </p>
              </div>

              {/* CARDS */}
              <div
                style={{
                  display: "flex",
                  gap: "34px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  marginTop: "40px",
                }}
              >
                {/* DEMO */}
                <Card hoverable style={{ width: 260, textAlign: "center" }}>
                  <h3>Request Demo</h3>
                  <p style={{ color: "#6b7280" }}>
                    See the platform in action with a quick walkthrough.
                  </p>
                  <Button
                    type="primary"
                    shape="round"
                    block
                    onClick={() => handleContact("demo")}
                  >
                    Book Demo
                  </Button>
                </Card>

                {/* SALES */}
                <Card hoverable style={{ width: 260, textAlign: "center" }}>
                  <h3>Talk to Sales</h3>
                  <p style={{ color: "#6b7280" }}>
                    Get pricing, plans, and custom solutions.
                  </p>
                  <Button
                    shape="round"
                    block
                    onClick={() => handleContact("sales")}
                  >
                    Contact Sales
                  </Button>
                </Card>

                {/* SUPPORT */}
                <Card hoverable style={{ width: 260, textAlign: "center" }}>
                  <h3>Support</h3>
                  <p style={{ color: "#6b7280" }}>
                    Facing issues? We’ll help you quickly.
                  </p>
                  <Button
                    shape="round"
                    block
                    onClick={() => handleContact("support")}
                  >
                    Get Help
                  </Button>
                </Card>
              </div>

              {/* TRUST LINE */}
              <div style={{ marginTop: "30px", color: "#9ca3af" }}>
                ⚡ Fast response • No spam • Real human support. Whatsapp:+91-9591270077
              </div>

            </div>
        </div>
        {contactType && (
          <div
            id="contact-form"
            style={{
              marginTop: "50px",
              maxWidth: "900px",
              marginLeft: "auto",
              marginRight: "auto",
              background: "#ffffff",
              padding: "24px",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              textAlign: "left"
            }}
          >
            <h3 style={{ marginBottom: "15px" }}>
              {contactType === "demo" && "Request Demo"}
              {contactType === "sales" && "Talk to Sales"}
              {contactType === "support" && "Support Request"}
            </h3>

            {/* NAME */}
            <div style={{ marginBottom: "12px" }}>
              <label>Name</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name"
                style={inputStyle}
              />
            </div>

            {/* EMAIL */}
            <div style={{ marginBottom: "12px" }}>
              <label>Email</label>
              <input
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                placeholder="Enter your email"
                style={inputStyle}
              />
            </div>

            {/* MESSAGE */}
            <div style={{ marginBottom: "12px" }}>
              <label>Message</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                style={{ ...inputStyle, resize: "none" }}
              />
            </div>

            {/* BUTTON */}
            <div style={{ textAlign: "center", marginTop: "15px" }}>
              <Button
                type="primary"
                shape="round"
                size="large"
                onClick={() => {
                  console.log({
                    type: contactType,
                    name,
                    email: userEmail,
                    message,
                  });

                  alert("Message sent! (connect API next)");
                }}
              >
                Send Message
              </Button>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="landing-footer">
        <Footer />
      </div>
    </div>
  );
}

export default QHRFlowContact;
